/* Nordele Gastro — Compare products
 * localStorage-backed multi-product comparison.
 * Storage key: ng_compare = array of product handles (max 4).
 */
(function () {
  var STORAGE_KEY = 'ng_compare';
  var MAX_PRODUCTS = 4;
  var productCache = {};

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr.slice(0, MAX_PRODUCTS))); } catch (e) {}
  }

  function getString(key) {
    var tpl = document.getElementById('ng-compare-tpl-strings');
    if (!tpl) return '';
    var el = tpl.content.querySelector('[data-key="' + key + '"]');
    return el ? el.textContent : '';
  }

  function syncBar() {
    var items = read();
    var bar = document.getElementById('ng-compare-bar');
    var countEl = document.getElementById('ng-compare-count');
    var chipsEl = document.getElementById('ng-compare-chips');
    if (!bar) return;
    bar.classList.toggle('ng-compare-bar--visible', items.length > 0);
    bar.setAttribute('aria-hidden', items.length > 0 ? 'false' : 'true');
    if (countEl) countEl.textContent = items.length;
    if (chipsEl) {
      chipsEl.innerHTML = '';
      items.forEach(function (item) {
        var chip = document.createElement('span');
        chip.className = 'ng-compare-bar__chip';
        var img = item.image ? '<img src="' + item.image + '" alt="">' : '';
        chip.innerHTML = img + '<span class="ng-compare-bar__chip-text">' + (item.title || item.handle) + '</span>' +
          '<button type="button" class="ng-compare-bar__chip-remove" data-handle="' + item.handle + '" aria-label="Remove">×</button>';
        chipsEl.appendChild(chip);
      });
    }
    // Sync card buttons
    document.querySelectorAll('[data-ng-compare]').forEach(function (btn) {
      var inCompare = items.some(function (i) { return i.handle === btn.dataset.handle; });
      btn.classList.toggle('ng-pcard__action--active', inCompare);
      btn.setAttribute('aria-pressed', inCompare ? 'true' : 'false');
    });
  }

  function toggle(handle, data) {
    var items = read();
    var idx = items.findIndex(function (i) { return i.handle === handle; });
    if (idx >= 0) {
      items.splice(idx, 1);
    } else {
      if (items.length >= MAX_PRODUCTS) {
        // Replace oldest
        items.shift();
      }
      items.push(data);
    }
    write(items);
    syncBar();
  }

  function clear() {
    write([]);
    syncBar();
  }

  function removeOne(handle) {
    var items = read().filter(function (i) { return i.handle !== handle; });
    write(items);
    syncBar();
  }

  async function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    try {
      var resp = await fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } });
      if (!resp.ok) throw new Error('HTTP ' + resp.status);
      var data = await resp.json();
      productCache[handle] = data;
      return data;
    } catch (e) {
      console.warn('[compare] fetch failed for', handle, e);
      return null;
    }
  }

  function pickSpec(product, paths) {
    for (var i = 0; i < paths.length; i++) {
      var parts = paths[i].split('.');
      var v = product;
      for (var j = 0; j < parts.length; j++) {
        if (v == null) { v = null; break; }
        v = v[parts[j]];
      }
      if (v !== null && v !== undefined && v !== '') return v;
    }
    return null;
  }

  async function renderModal() {
    var items = read();
    var body = document.getElementById('ng-compare-modal-body');
    if (!body) return;
    if (items.length === 0) {
      body.innerHTML = '<div class="ng-compare-modal__empty">Ingen produkter valgt.</div>';
      return;
    }
    body.innerHTML = '<div class="ng-compare-modal__loading">' + getString('view') + '…</div>';

    var products = await Promise.all(items.map(function (i) { return fetchProduct(i.handle); }));
    products = products.filter(Boolean);

    if (products.length === 0) {
      body.innerHTML = '<div class="ng-compare-modal__empty">Kunne ikke hente produkter.</div>';
      return;
    }

    // Build spec rows. Each row: label + value per product.
    // Use known metafield paths for tech specs.
    var rows = [
      { label: 'Brand', get: function (p) { return p.vendor; } },
      { label: 'Type', get: function (p) { return p.type; } },
      { label: 'Pris', get: function (p) {
        var price = p.price / 100;
        return price.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr.';
      } },
      { label: 'Tilgængelighed', get: function (p) { return p.available ? '✓ På lager' : '⚠ Bestillingsvare'; } },
      { label: 'Bredde', get: function (p) {
        // Try multiple metafield namespaces
        var w = pickSpec(p, ['metafields.combisteel_specs.width_mm', 'metafields.tefcold_specs.width_mm']);
        return w ? w + ' mm' : '—';
      } },
      { label: 'Dybde', get: function (p) {
        var d = pickSpec(p, ['metafields.combisteel_specs.depth_mm', 'metafields.tefcold_specs.depth_mm']);
        return d ? d + ' mm' : '—';
      } },
      { label: 'Spænding', get: function (p) {
        var v = pickSpec(p, ['metafields.combisteel_specs.voltage_volt', 'metafields.tefcold_specs.voltage_volt']);
        return v ? v + ' V' : '—';
      } },
      { label: 'Kapacitet', get: function (p) {
        var c = pickSpec(p, ['metafields.combisteel_specs.capacity_ltr', 'metafields.tefcold_specs.capacity_ltr']);
        return c ? c + ' L' : '—';
      } },
    ];

    var html = '<div class="ng-compare-table-wrap"><table class="ng-compare-table">';
    // Image + title row
    html += '<thead><tr><th class="ng-compare-table__label"></th>';
    products.forEach(function (p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      html += '<th class="ng-compare-table__product">' +
        '<button type="button" class="ng-compare-table__remove" data-handle="' + p.handle + '" aria-label="' + getString('remove') + '">×</button>' +
        '<a href="/products/' + p.handle + '" class="ng-compare-table__img-link">' +
        (img ? '<img src="' + img + '" alt="' + (p.title || '') + '" class="ng-compare-table__img">' : '<div class="ng-compare-table__no-img"></div>') +
        '</a>' +
        '<a href="/products/' + p.handle + '" class="ng-compare-table__name">' + (p.title || '') + '</a>' +
        '</th>';
    });
    html += '</tr></thead><tbody>';

    rows.forEach(function (row) {
      var values = products.map(function (p) { return row.get(p); });
      var allSame = values.every(function (v) { return String(v) === String(values[0]); });
      html += '<tr class="' + (allSame ? '' : 'ng-compare-table__row--differs') + '">';
      html += '<td class="ng-compare-table__label">' + row.label + '</td>';
      values.forEach(function (v) {
        html += '<td class="ng-compare-table__value">' + (v != null && v !== '' ? v : '—') + '</td>';
      });
      html += '</tr>';
    });

    // Action row
    html += '<tr class="ng-compare-table__actions-row"><td></td>';
    products.forEach(function (p) {
      var variantId = p.variants && p.variants[0] && p.variants[0].id;
      html += '<td>' +
        (variantId ? '<button type="button" class="ng-compare-table__cta" data-ng-add-to-cart data-variant-id="' + variantId + '">' + getString('add_to_cart') + '</button>' : '') +
        '<a href="/products/' + p.handle + '" class="ng-compare-table__view">' + getString('view') + ' →</a>' +
        '</td>';
    });
    html += '</tr>';
    html += '</tbody></table></div>';

    body.innerHTML = html;
  }

  function openModal() {
    var modal = document.getElementById('ng-compare-modal');
    if (!modal) return;
    modal.classList.add('ng-compare-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderModal();
  }

  function closeModal() {
    var modal = document.getElementById('ng-compare-modal');
    if (!modal) return;
    modal.classList.remove('ng-compare-modal--open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function init() {
    // Card button clicks
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ng-compare]');
      if (btn) {
        e.preventDefault();
        toggle(btn.dataset.handle, {
          handle: btn.dataset.handle,
          title: btn.dataset.title || '',
          vendor: btn.dataset.vendor || '',
          image: btn.dataset.image || '',
          price: btn.dataset.price || '',
        });
        return;
      }
      // Bar chip remove
      var chipRemove = e.target.closest('.ng-compare-bar__chip-remove');
      if (chipRemove) { removeOne(chipRemove.dataset.handle); return; }
      // Bar open
      if (e.target.id === 'ng-compare-open' || e.target.closest('#ng-compare-open')) { openModal(); return; }
      // Bar clear
      if (e.target.id === 'ng-compare-clear' || e.target.closest('#ng-compare-clear')) { clear(); return; }
      // Modal close
      if (e.target.matches('[data-ng-compare-close]') || e.target.closest('[data-ng-compare-close]')) { closeModal(); return; }
      // Modal table remove
      var tblRemove = e.target.closest('.ng-compare-table__remove');
      if (tblRemove) {
        removeOne(tblRemove.dataset.handle);
        renderModal();
        return;
      }
    });

    // Initial sync from localStorage
    syncBar();

    // Sync across tabs
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) syncBar();
    });

    // Esc closes modal
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
